import { useMemo } from 'react';
import { SectionCard, fmtTRY } from '../yeni-design/primitives';
import { haftaGunleri, type HaftaGunu } from './analizHesaplari';
import { BlokIskeleti } from './BlokIskeleti';
import type { Donem } from './donem';
import type { SaKaynak } from './ekranKaynaklari';
import { fisOzeti, type KanalSatiri } from './ozetHesaplari';
import { useSaSorgu } from './useSatisVerisi';

interface Props {
  kaynak: SaKaynak | undefined;
  donem: Donem;
  sube?: string | null;
  kanal?: string | null;
}

/** Genel : haftanin gunlerine gore ortalama ciro (990040, sayfa anahtari; ek istek yok). Tek gunde anlamsiz, cizilmez. */
export function GunDagilimBlok({ kaynak, donem, sube = null, kanal = null }: Props) {
  const q = useSaSorgu<KanalSatiri>(kaynak, { donem, sube: null, kanal: null }, !donem.tekGun);
  const gunler = useMemo(() => haftaGunleri(fisOzeti(q.data?.data ?? [], sube, kanal).gunluk), [q.data, sube, kanal]);

  if (!kaynak || donem.tekGun) return null;
  if (q.isLoading) return <BlokIskeleti testid="blok-gun-dagilim-iskelet" baslik="Haftanın günleri" yukseklik={220} satir={7} />;
  if (gunler.length < 2) return null;

  return <HaftaGunleriKarti testid="blok-gun-dagilim" kok="gun-dagilim" altBaslik="Gün başına ortalama ciro" gunler={gunler} />;
}

/** Haftanin gunleri kart gorunumu: Satis (ciro) ve Stok (fire) ayni kalip. */
export function HaftaGunleriKarti({ testid, kok, altBaslik, gunler }: {
  testid: string; kok: string; altBaslik: string; gunler: HaftaGunu[];
}) {
  const enYuksek = Math.max(...gunler.map((g) => g.ortalama), 1);
  return (
    <div data-testid={testid}>
      <SectionCard title="Haftanın günleri" subtitle={altBaslik}>
        <ul className="m-0 p-0 list-none flex flex-col gap-2.5">
          {gunler.map((g) => (
            <li key={g.ad} data-testid={`${kok}-${g.ad}`} className="grid grid-cols-[32px_1fr_auto] items-center gap-3 text-[13px]">
              <span className="text-ink-600">{g.ad}</span>
              <div className="h-2 rounded-full bg-border-light overflow-hidden">
                <div
                  className={`h-full rounded-full ${g.ortalama === enYuksek ? 'bg-ink-900' : 'bg-ink-400'}`}
                  style={{ width: `${Math.max(0, (g.ortalama / enYuksek) * 100)}%` }}
                />
              </div>
              <span className="tnum text-ink-900">{fmtTRY(g.ortalama)}</span>
            </li>
          ))}
        </ul>
      </SectionCard>
    </div>
  );
}
